<template>
    <el-card>
        <div slot="header" class="move">
            <h3>Settled Deals</h3>
        </div>
        <bar-chart
            :data="datasets"
            :options="options"
            :style="{'height': height + 'px'}"
        ></bar-chart>

        <div class="card-footer border text-center py-3">
            <div class="row">
                <div class="col px-2">
                    <div class="text-muted small mb-1">Settled</div>
                    <strong class="text-big">{{ settledTotal }}</strong>
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
import BarChart from '../../ambition/dashboard/charts/BarChart'

export default {
    name: 'SettledChart',
    components: {
        BarChart
    },
    props: [
        'appearance',
        'tenantId',
        'dashboardId'
    ],
    data() {
        return {
            settledHistory: [],
            datasets: [],
            settledTotal: 0,
            height: 110,
            options: {
                scales: {xAxes: [{display: false,}], yAxes: [{display: false, ticks: {beginAtZero: true}}]},
                legend: {display: false},
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        top: 25  //set that fits the best
                    }
                },
                tooltips: {
                    mode: "label",
                    fullWidth: true,
                    titleFontFamily: "Poppins",
                    titleFontSize: 12,
                    titleMarginBottom: 10,
                    bodyFontFamily: "Poppins",
                    bodyFontSize: 12,
                    bodySpacing: 15,
                    cornerRadius: 0,
                    xPadding: 10,
                    yPadding: 10,
                    backgroundColor: 'rgba(8,7,48,0.8)'
                }
            },
            metrics: {
                settled_deals: 0,
                naf: 0,
                commissions_earned: 0,
                tweened_settled_deals: 0,
                tweened_naf: 0,
                tweened_commissions_earned: 0,
            },
        }
    },
    mounted() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.settledHistory = event.settledDeal.settled
            this.settledTotal = _.sum(Object.values(this.settledHistory.values))
            let labels = Object.values(this.settledHistory.labels)

            this.datasets = {
                datasets: [{
                    label: 'Settled',
                    backgroundColor: '#3F51B5',
                    data: Object.values(this.settledHistory.values)
                }],
                labels: labels
            }

            this.graphColorChange()
        })
    },
    created() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.settledHistory = event.settledDeal.settled
            this.settledTotal = _.sum(Object.values(this.settledHistory.values))
            let labels = Object.values(this.settledHistory.labels);

            this.datasets = {
                datasets: [{
                    label: 'Settled',
                    backgroundColor: this.graphBGColorChange(),
                    data: Object.values(this.settledHistory.values)
                }],
                labels: labels
            }

            this.graphColorChange()
        })
    },
    computed: {},
    watch: {},
    destroyed() {
        Echo.leave(`dashboard.${this.tenantId}.${this.dashboard}`)
    },
    methods: {
        graphBGColorChange() {
            return this.appearance == "white" ? "#fff" : "#000"
        },
        graphColorChange() {
            return this.appearance == 'black' ? "#fff" : "#000"
        }
    }
}
</script>

<style scoped>
.move {
    cursor: move;
}
</style>
